import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';
import Hidden from "@material-ui/core/Hidden";
import { OrderParameter } from "../../lib/OrderParameters";
import { SketchOrderSortParameter } from "../../lib/sketchOrderSortParameters";
import { getOwnersSketchOrders, getSketchOrders } from "../../actions/sketchOrdersActions";
import SketchOrderTable from "../../components/SketchOrderTable/SketchOrderTable";
import SketchOrderList from "../../components/SketchOrderList/SketchOrderList";
import { SketchOrderSortParameter as sketchOrderSortParameter } from '../../lib/sketchOrderSortParameters';
import { OrderParameter as orderParameter } from '../../lib/OrderParameters';

export class AllSketchOrders extends Component {
    state = {
        sort: sketchOrderSortParameter.DueDate,
        order: orderParameter.Ascending,
        canSort: true,
        filterStorm: false,
    };

    getSketchOrders = async (page = 1) => {
        const isAdminOrSketchOSAdmin = (this.props.currentUserRoles.isAdmin || this.props.currentUserRoles.isSketchOsAdmin);

        const queryParams = queryString.parse(this.props.location.search);

        // If we have the owner filter on, go get the owner's sketch orders
        if (queryParams.ownerUserId) {
            // This call does not support sorting
            this.setState({
                canSort: false,
            });
            await this.props.dispatch(getOwnersSketchOrders(queryParams.ownerUserId, page));
            return;
        }

        const rushOrders = queryParams.rush;
        const metalRoof = queryParams.metalRoof;

        const {
            statusIds,
            organizationId,
            requesterUserId
        } = queryParams;
        let statusesToFilterBy;
        if (statusIds && !Array.isArray(statusIds)) {
            statusesToFilterBy = [];
            statusesToFilterBy.push(statusIds);
        } else {
            statusesToFilterBy = statusIds;
        }

        let ordering;
        let sorting;
        if (!this.state.order) {
            ordering = isAdminOrSketchOSAdmin ? OrderParameter.Ascending : null;
        } else {
            ordering = this.state.order;
        }
        if (!this.state.sort) {
            sorting = isAdminOrSketchOSAdmin ? SketchOrderSortParameter.AdminPriority : null;
        } else {
            sorting = this.state.sort;
        }

        // Make sure to turn sorting on
        this.setState({
            canSort: true,
        });
        await this.props.dispatch(
            getSketchOrders(
                page,
                statusesToFilterBy,
                null,
                organizationId,
                ordering,
                sorting,
                null,
                requesterUserId,
                this.state.filterStorm,
                rushOrders,
                metalRoof
            )
        );
    };

    async componentDidMount() {
        await this.getSketchOrders();
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            await this.getSketchOrders();
        }
    };

    getNextPage = async () => {
        const nextPage = this.props.currentPage + 1;
        await this.getSketchOrders(nextPage);
    };

    getPrevPage = async () => {
        const prevPage = this.props.currentPage - 1;
        await this.getSketchOrders(prevPage);
    };

    handleOnSortClick = (sort, order) => {
        this.setState({
            sort,
            order,
        }, async () => {
            await this.getSketchOrders();
        });
    };

    handleStormFilterClick = () => {
        this.setState({
            filterStorm: !this.state.filterStorm,
        }, async () => {
            await this.getSketchOrders();
        });
    };

    render() {
        const isSketchOsAdmin = () => this.props.currentUserRoles.isAdmin || this.props.currentUserRoles.isSketchOsAdmin;

        const queryParams = queryString.parse(this.props.location.search);
        const {
            statusIds,
            organizationId,
            requesterUserId,
            ownerUserId,
        } = queryParams;

        const numberOfStatusFilters = () => {
            if (!statusIds) {
                return 0;
            }

            if (!Array.isArray(statusIds)) {
                return 1;
            }

            return statusIds.length;
        };
        const numberOfOrganizationFilters = (organizationId) ? 1 : 0;
        const numberOfRequesterFilters = (requesterUserId) ? 1 : 0;
        const numberOfOwnerFilters = (ownerUserId) ? 1 : 0;

        return (
            <div>
                <Hidden smDown>
                    <SketchOrderTable
                        sketchOrders={this.props.sketchOrders}
                        sketchOrderIds={this.props.sketchOrderIds}
                        totalOrders={this.props.totalResults}
                        currentPage={this.props.currentPage}
                        totalPages={this.props.totalPages}
                        onNextPageClick={this.getNextPage}
                        onPrevPageClick={this.getPrevPage}
                        showOrganizationName={isSketchOsAdmin()}
                        numberOfStatusFilters={numberOfStatusFilters()}
                        numberOfOrganizationFilters={numberOfOrganizationFilters}
                        numberOfRequesterFilters={numberOfRequesterFilters}
                        numberOfOwnerFilters={numberOfOwnerFilters}
                        canFilter
                        showProjectName={isSketchOsAdmin()}
                        showStatus
                        canSortByRequestedDate={this.state.canSort}
                        canSortByUpdatedDate={this.state.canSort}
                        canSortByDueDate={this.state.canSort}
                        canFilterByOrganization={isSketchOsAdmin()}
                        canFilterByRequester={isSketchOsAdmin()}
                        canFilterByOwner={isSketchOsAdmin()}
                        showAddress={isSketchOsAdmin()}
                        showRequester={false}
                        showSketchTech
                        showDueDate
                        showLinksToSupportDashboard={this.props.currentUserRoles.isAdmin}
                        showTimeSinceRequested
                        showLastUpdatedAtTime
                        isFetching={this.props.isFetching}
                        onSortClick={this.handleOnSortClick}
                        sort={this.state.sort}
                        order={this.state.order}
                        currentUserName={this.props.currentUserName}
                        showReviewer={isSketchOsAdmin()}
                        filterStormClick={this.handleStormFilterClick}
                        filterStorm={this.state.filterStorm}
                        showStormFilter
                    />
                </Hidden>
                <Hidden mdUp>
                    <SketchOrderList
                        sketchOrders={this.props.sketchOrders}
                        sketchOrderIds={this.props.sketchOrderIds}
                        totalOrders={this.props.totalResults}
                        currentPage={this.props.currentPage}
                        totalPages={this.props.totalPages}
                        onNextPageClick={this.getNextPage}
                        onPrevPageClick={this.getPrevPage}
                        showOrganizationName={isSketchOsAdmin()}
                        numberOfStatusFilters={numberOfStatusFilters()}
                        numberOfOrganizationFilters={numberOfOrganizationFilters}
                        numberOfRequesterFilters={numberOfRequesterFilters}
                        numberOfOwnerFilters={numberOfOwnerFilters}
                        canFilter
                        showStatus
                        canFilterByOrganization={isSketchOsAdmin()}
                        canFilterByRequester={isSketchOsAdmin()}
                        canFilterByOwner={isSketchOsAdmin()}
                        showOwner={isSketchOsAdmin()}
                        showRequester={isSketchOsAdmin()}
                        isFetching={this.props.isFetching}
                        currentUserName={this.props.currentUserName}
                        filterStormClick={this.handleStormFilterClick}
                        filterStorm={this.state.filterStorm}
                        showStormFilter
                    />
                </Hidden>
            </div>
        );
    }
}

AllSketchOrders.propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
    }).isRequired,
    sketchOrders: PropTypes.shape({
        sketchOrder: PropTypes.shape({
            id: PropTypes.number.isRequired,
            projectName: PropTypes.string,
            requestedDate: PropTypes.string,
            address: PropTypes.string,
            city: PropTypes.string,
            region: PropTypes.string,
            postCode: PropTypes.string,
            country: PropTypes.string,
            sketchOrderStatus: PropTypes.string,
            cost: PropTypes.number,
            reviewer: PropTypes.string,
        })
    }).isRequired,
    totalResults: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    currentUserRoles: PropTypes.shape({
        isAdmin: PropTypes.bool.isRequired,
        isSketchOsAdmin: PropTypes.bool.isRequired,
        isSketchTech: PropTypes.bool.isRequired,
    }),
    isFetching: PropTypes.bool.isRequired,
    currentUserName: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    const {
        sketchOrders: sketchOrdersStore,
        currentUserRoles,
        currentUser,
    } = state;
    const {
        sketchOrders,
        totalResults,
        currentPage,
        totalPages,
        isFetching,
        ids: sketchOrderIds,
    } = sketchOrdersStore;
    const { userName: currentUserName } = currentUser;

    return {
        sketchOrders,
        totalResults,
        currentPage,
        totalPages,
        currentUserRoles,
        isFetching,
        currentUserName,
        sketchOrderIds,
    }
};

export default connect(mapStateToProps)(AllSketchOrders);
